import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiChip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';

export const Root = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '16px',
  backgroundColor: theme.palette.neutrals.beige2,
  borderRadius: '16px',
  marginBottom: theme.spacing(3),
  padding: '20px'
}));

export const Chip = styled(MuiChip)(({ theme }) => ({
  backgroundColor: theme.palette.brand.darkGreen,
  color: theme.palette.neutrals.beige1,
  borderRadius: '4px'
}));

export const DayGroup = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  width: '100%'
}));

export const DayLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.brand.darkGreen
}));

export const ChipList = styled(Box)(() => ({
  display: 'flex',
  gap: '8px',
  flexWrap: 'wrap',
  alignItems: 'center'
}));

export const TimeChip = styled(MuiChip)(({ theme }) => ({
  ...theme.typography.body1R,
  borderColor: theme.palette.neutrals.beige4,
  color: theme.palette.brand.darkGreen,
  borderRadius: '100px',
  cursor: 'pointer',
  '&.selected': {
    backgroundColor: theme.palette.brand.darkGreen,
    borderColor: theme.palette.brand.darkGreen,
    color: theme.palette.neutrals.beige1
  }
}));
